module.exports = __webpack_public_path__ + "static/media/account_icon_level4.fd20c930.svg";